export default "__VITE_ASSET__DJZUUqlt__"